module.exports = __webpack_public_path__ + "static/media/amex.b607e188.png";